import { useUserContext } from '@/components/user-context/user-context-provider';
import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

import { RovoDevSignupUnavailable } from '../rovo-dev-signup-unavailable';

import { LoggedInDevAIFree } from './free/logged-in-devai-free';
import { LoggedInRovoDevStandard } from './standard/logged-in-rovo-dev-standard';

export const LoggedInDevAI = (): JSX.Element => {
	const { edition } = useUserContext();

	if (checkFeatureFlagGate(featureFlags.killRovoDevSignup)) {
		return <RovoDevSignupUnavailable />;
	}

	if (edition === 'free' && checkFeatureFlagGate(featureFlags.enableRovoDevBetaSignup)) {
		return <LoggedInDevAIFree />;
	}

	return <LoggedInRovoDevStandard />;
};
